import { Paises } from "@/enum/paises.enum";
import { z } from "zod";

export const BasicInfoSchema = z
  .object({
    tipoDocumento: z
      .string({
        required_error: "Campo obligatorio",
      })
      .nonempty("Campo obligatorio"),
    numeroDocumento: z
      .string({
        required_error: "Campo obligatorio",
      })
      .min(3, "El número de documento debe tener al menos 3 caracteres"),
    correo: z
      .string({
        required_error: "El correo electrónico es obligatorio",
      })
      .email("El correo es inválido")
      .nonempty("Campo obligatorio"),
    nombreRazonSocial: z
      .string({
        required_error: "Campo obligatorio",
      })
      .min(2, "El nombre o razón social es obligatorio"),
    direccion: z
      .string({
        required_error: "Campo obligatorio",
      })
      .min(3, "La dirección principal es obligatoria"),
    pais: z
      .string({
        required_error: "El pais es obligatorio",
      })
      .nonempty("El país es obligatorio"),
    departamento: z.string().optional(),
    ciudad: z.string().optional(),
    tipoEmpresa: z
      .enum(["Publica", "Mixta", "Privada", "Extranjera"])
      .optional(), // solo aplica si tipoDocumento === NIT
  })
  .superRefine((data, ctx) => {
    const pais = data.pais;

    // Si el país es diferente a Colombia solo se valida la ciudad
    if (pais && pais !== Paises.Colombia) {
      if (!data.ciudad || !data.ciudad.trim()) {
        ctx.addIssue({
          path: ["ciudad"],
          code: "custom",
          message: "La ciudad es obligatoria",
        });
      }
    }

    // Si el pais es Colombia se valida departamento y ciudad
    if (pais === Paises.Colombia) {
      if (!data.departamento || !data.departamento.trim()) {
        ctx.addIssue({
          path: ["departamento"],
          code: "custom",
          message: "El departamento es obligatorio",
        });
      }

      if (data.departamento && (!data.ciudad || !data.ciudad.trim())) {
        ctx.addIssue({
          path: ["ciudad"],
          code: "custom",
          message: "La ciudad es obligatoria",
        });
      }
    }

    if (data.tipoDocumento === "NIT" && !data.tipoEmpresa) {
      ctx.addIssue({
        path: ["tipoEmpresa"],
        code: "custom",
        message: "Seleccione un tipo de empresa",
      });
    }
  });

export type BasicInfoDto = z.infer<typeof BasicInfoSchema>;
